import type { FastCheckoutMethod } from '@design-system/composables/useFastCheckoutMethods'

let isAdyenPreloaded = false

const whenIdle = (callback: () => void) => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback, { timeout: 2000 })
    return
  }
  setTimeout(callback, 1)
}

/**
 * Warms up the Adyen bundle as soon as the PDP knows which fast methods it
 * shows, so that once a size is picked Apple Pay and Google Pay do not wait
 * for it. PayPal needs no preload: its button is rendered on landing (see
 * `PdpEcommerceBlockProductFastCheckoutWallet`).
 *
 * @returns `preload`, to call with the methods the PDP shows.
 */
export const useFastCheckoutPreload = () => {
  const preload = (methods: FastCheckoutMethod[]) => {
    if (!import.meta.client || isAdyenPreloaded) return
    const hasAdyenWallet =
      methods.includes('applePay') || methods.includes('googlePay')
    if (!hasAdyenWallet) return

    whenIdle(() => {
      if (isAdyenPreloaded) return
      isAdyenPreloaded = true
      import('@adyen/adyen-web').catch(() => {
        isAdyenPreloaded = false
      })
    })
  }

  return { preload }
}
